// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/webapp/styles/main.scss
// module id = ./resources/webapp/styles/main.scss
// module chunks = 1